import { createAsyncThunk } from '@reduxjs/toolkit';
import { UPDATE_TOGGLE_SETTINGS_API_URL } from '@custom/constant';

// Async thunk to add a teleradiology customer
export const toggleTools = createAsyncThunk(
    'settings/updateSettings',
    async (data: any, { rejectWithValue }) => {
        console.log('data', data)
        try {
            const token = sessionStorage.getItem('token') || localStorage.getItem('token');
            const userId = sessionStorage.getItem('userId') || localStorage.getItem('userId');
            const payload = {
                userId: userId,
                toolsSettings: data.toolsSettings,
                overlaySettings: data.overlaySettings
            }
            const response = await fetch(UPDATE_TOGGLE_SETTINGS_API_URL, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Failed to update settings');
            }

            return await response.json(); // Return the response data if successful
        } catch (error: any) {
            return rejectWithValue(error.message); // Handle any errors that occur
        }
    }
);

export default toggleTools;
